export default {
  requests: {
    value: '',
    compare: '<=',
  },
  responses: {
    value: '',
    compare: '<=',
  },
  wins: {
    value: '',
    compare: '<=',
  },
  avgCPM: {
    value: '',
    compare: '<=',
  },
  spent: {
    value: '',
    compare: '<=',
  },
  clicks: {
    value: '',
    compare: '<=',
  },
};
